<template>
  <div class="action-connection-container" :class="device.isMobile ? 'action-connection-container-mobile' : ''">
    <div class="reset" @click.stop="reset"></div>
    <div class="action-content">
      <div class="action-left">
        <div class="action-left-item" v-for="item in content.leftData" :key="item.key">
          <img :src="item.cover" :alt="item.title" :title="item.title">
        </div>
      </div>
      <div class="action-right">
        <div
          class="action-right-item"
          v-for="(item, index) in resultData"
          :key="index"
        >
          <draggable
            :key="index"
            class="action-handle"
            :sort="false"
            :disabled="false"
            :group="{
              name: content.key,
              pull: false,
              put: dropChecked(item)
            }"
            @add="dropHandle($event, item, index)"
            v-model="item.newArr"
          >
            <div class="" v-for="(it, idx) in item.newArr" :key="idx">
              <img v-if="it.cover" :src="it.cover" :alt="it.title" :title="it.title">
              <span v-else-if="it.text">{{ it.text }}</span>
            </div>
          </draggable>
          <div v-if="item.mark === 'left'" class="action-right-unknown"></div>
          <div v-if="item.isTrue" class="isTrue" :class="item.isTrue === 1 ? 'true-icon' : item.isTrue === 2 ? 'false-icon' : ''"></div>
        </div>
      </div>
    </div>
    <div class="action-handle-info">
      {{ content.info || '请拖动下方备选吉祥物，以完成左侧品牌和右侧吉祥物的一一对应。' }}
      <!-- <el-button type="text" @click="checkAnwser">校验答案</el-button> -->
    </div>
    <draggable
      class="action-bottom-handle"
      :sort="false"
      :group="{
        name: content.key,
        pull: true,
        put: false
      }"
      @start="dragstartHandle($event)"
      v-model="handleData"
    >
      <template v-for="item in handleData">
        <div
          :key="item.key"
          v-if="!item.hideInHandle"
          class="action-handle-item"
          :class="item.text ? 'action-handle-text-item' : ''"
        >
          <img v-if="item.cover" :src="item.cover" :alt="item.title" :title="item.title" @touchstart.prevent>
          <div v-else-if="item.text">{{ item.text }}</div>
        </div>
      </template>
    </draggable>
  </div>
</template>
<script>
/*
交互动作组件 -- 连一连
*/
import draggable from "vuedraggable";
import { getActionData, setActionData } from "@/utils/storage";
export default {
  name: "connectionAction",
  components: {
    draggable
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      resultData: [],
      handleData: [],
      historyData: null,
      dragIndex: 0,
      dragKey: '',
    }
  },
  mounted() {
    this.historyData = (JSON.parse(getActionData()) || {})
    let historyData = this.historyData[this.content.key]
    this.resultData = this.content.leftData.map((item, index) => {
      let returnData = this.content.rightData.find(right => {
        return right.answerKey == item.answerKey
      });
      returnData = JSON.parse(JSON.stringify(returnData))
      returnData.mark = 'left'
      returnData.newArr = []
      if(historyData && historyData[index]) {
        returnData.mark = 'right'
        returnData.isTrue = 1
        returnData.newArr.push(returnData)
      }
      return returnData
    })
    this.handleData = this.content.rightData.filter(item => {
      return !(historyData && historyData.includes(item.key))
    });
  },
  methods: {
    dragstartHandle(e) {
      let handleData = this.handleData[e.oldIndex];
      this.dragKey = handleData.answerKey;
      this.dragIndex = e.oldIndex;
    },
    dropChecked(item) {
      if(item.newArr.length > 0) return false;
      return true
    },
    dropHandle(event, item, index) {
      let handleIndex = this.dragIndex
      let resultIndex = index

      if(this.resultData[resultIndex].newArr[0].answerKey !== this.resultData[resultIndex].answerKey) {
        let changeData = this.resultData[resultIndex].newArr[0]
        this.$set(this.resultData[resultIndex], 'newArr', [])
        this.handleData.splice(handleIndex, 0, changeData)
        this.$forceUpdate()
        return false
      }

      // this.$set(this.handleData[handleIndex], 'hideInHandle', true)
      this.$set(this.resultData[resultIndex], 'mark', 'right')
      this.$set(this.resultData[resultIndex], 'isTrue', 1)
      
      
      let historyData = {}
      historyData[this.content.key] = this.resultData.map(result => (result.newArr[0] || {}).key);
      this.historyData = Object.assign({}, this.historyData, historyData)
      setActionData(JSON.stringify(this.historyData));
    },
    // 拖拽直接显示正确答案，不正确的拖拽不进去
    dropHandle2(e, item, index) {
      console.log(11111)
      console.log(e, item, index)
      let data = e.dataTransfer.getData("content");
      data = JSON.parse(data)
      if(data.actionKey !== this.content.key) {
        return false
      }
      if(data.dragType === 'handle') {
        console.log(data, this.content.leftData[index].answerKey)
        if(data.answerKey === this.content.leftData[index].answerKey) {
          if(this.resultData[index].key) {
            let handleShowIndex = this.handleData.findIndex(i => i.key === item.key)
            this.$set(this.handleData[handleShowIndex], 'hideInHandle', false)
          }
          // 从数据栏拖拽到操作栏，隐藏已经加入过的数据栏的数据
          this.$set(this.resultData, index, data)
          this.$set(this.resultData[index], 'mark', 'right')
          this.$set(this.resultData[index], 'isTrue', 1)
          let handleIndex = this.handleData.findIndex(i => i.key === data.key)
          this.$set(this.handleData[handleIndex], 'hideInHandle', true)

          // let historyData = this.resultData.map(item => item.key);
          let historyData = {}
          historyData[this.content.key] = this.resultData.map(item => item.key);
          this.historyData = Object.assign({}, this.historyData, historyData)
          setActionData(JSON.stringify(this.historyData));
        }
      }
    },
    // 拖拽不会直接显示答案，需要触发才判定是否正确
    dropHandle1(e, item, index) {
      let data = e.dataTransfer.getData("content");
      data = JSON.parse(data)
      if(data.actionKey !== this.content.key) {
        return false
      }
      if(data.dragType === 'handle') {
        if(this.resultData[index].key) {
          let handleShowIndex = this.handleData.findIndex(i => i.key === item.key)
          this.$set(this.handleData[handleShowIndex], 'hideInHandle', false)
        }
        // 从数据栏拖拽到操作栏，隐藏已经加入过的数据栏的数据
        this.$set(this.resultData, index, data)
        this.$set(this.resultData[index], 'mark', 'right')
        let handleIndex = this.handleData.findIndex(i => i.key === data.key)
        this.$set(this.handleData[handleIndex], 'hideInHandle', true)
      }else if(data.dragType === 'result'){
        // 同级拖拽不排序，互换位置  
        let handleIndex = this.resultData.findIndex(i => i.key === data.key)
        let handleData = this.resultData[handleIndex]
        
        this.$set(this.resultData, handleIndex, item)
        this.$set(this.resultData, index, handleData)
      }
      let newAnswer = this.resultData.map(item => {
        return item.answerKey || ''
      })
      this.$emit('updateAnswer', newAnswer)
    },
    // 重置整个内容
    reset() {
      this.handleData = this.content.rightData.map(item => {
        item.hideInHandle = false
        return item
      });
      this.resultData = this.content.leftData.map(item => {
        // item = {}
        item.mark = 'left'
        item.newArr = []
        item.isTrue = 0
        return item
      })
      
      delete this.historyData[this.content.key]
      setActionData(JSON.stringify(this.historyData));
    },
    // 检查问题是否答对
    checkAnwser() {
      let isComplete = true
      this.resultData.forEach(item => {
        if(item.mark === 'left') {
          isComplete = false
        }
      })
      if(!isComplete) {
        this.$message.error('请先完成答题')
        return false
      }

      this.resultData = this.resultData.map((item, index) => {
        console.log(index)
        if(item.answerKey === this.content.leftData[index].answerKey) {
          item.isTrue = 1
        }else{
          item.isTrue = 2
        }
        return item
      })
    },
  },
}
</script>


<style lang="scss" scoped>
.action-connection-container{

  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: 11rem;
    right: 14rem;
    cursor: pointer;
  }

  .action-content{
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .action-left{
      .action-left-item{
        margin: 20rem 0;
        width: 230rem;
        height: 100rem;
        display: flex;
        align-items: center;
        position: relative;

        img{
          display: block;
          max-width: 230rem;
          max-height: 100rem;
        }

        &:after{
          content: '';
          width: 185rem;
          height: 1px;
          display: block;
          position: absolute;
          top: 50%;
          right: -215rem;
          border-top: 1px dashed #C1C1C1;
        }
      }
    }

    .action-right{
      padding-right: 70rem;
      .action-right-item{
        width: 100rem;
        height: 100rem;
        margin: 20rem 0;
        border: 1px dashed #C1C1C1;
        display: flex;
        align-items: center;
        position: relative;
        background: #fff;
        .action-handle{
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .action-right-unknown{
          width: 30rem;
          height: 48rem;
          background: url(~@/assets/images/books/bookExample/connection-unknown.png) center center no-repeat;
          background-size: contain;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        >div{
          display: flex;
          align-items: center;
          justify-content: center;
          span{
            padding: 0 10rem;
            font-size: 24rem;
            color: #333;
            line-height: 26rem;
            display: block;
          }
        }

        img{
          display: block;
          max-width: 80rem;
          max-height: 80rem;
          margin: 10rem auto;
        }

        .isTrue{
          position: absolute;
          top: 50%;
          right: -62rem;
          transform: translateY(-50%);
          width: 48rem;
          height: 48rem;
        }

        .true-icon{
          background: url(~@/assets/images/books/bookExample/true-icon.png) center center no-repeat;
          background-size: contain;
        }

        .false-icon{
          background: url(~@/assets/images/books/bookExample/false-icon.png) center center no-repeat;
          background-size: contain;
        }
      }
    }
  }

  .action-handle-info{
    margin-top: 10rem;
    font-size: 18rem;
    color: #666;
  }

  .action-bottom-handle{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    min-height: 102rem;
    padding: 15rem;
    background: #FFFFFF;
    border: 1px solid #E3E3E3;

    .action-handle-item{
      margin-right: 18rem;
      cursor: pointer;
      img{
        display: block;
        max-width: 70rem;
        max-height: 70rem;
      }
    }

    .action-handle-text-item{
      margin-right: 30rem;

      >span{
        white-space: nowrap;
      }
    }
  }
}

.action-connection-container-mobile{
  .reset{
    width: 44rem;
    height: 44rem;
  }
  
  .action-content{
    .action-left{
      .action-left-item{
        margin: 35rem 0;
      }
    }

    .action-right{
      .action-right-item{
        margin: 35rem 0;
      }
    }
  }

  .action-handle-info{
    font-size: 20rem;
  }
  
  .action-bottom-handle{
    min-height: 122rem;

    .action-handle-item{
      img{
        max-width: 90rem;
        max-height: 90rem;
      }
    }
  }
}
</style>